module.exports = __webpack_public_path__ + "img/ico_tiktok.fbbf5784.svg";